export default "__VITE_ASSET__DXeF5mzD__"